import React from 'react';
import HeaderNavigation from 'components/layout/header/HeaderNavigation';
import FooterMain from 'components/layout/footer/FooterMain';
import FAQHeader from 'components/layout/faq/FAQHeader';
import FAQText from 'components/layout/faq/FAQText';
import styles from 'styles/pages/FAQPage.module.sass';

/**
 * FAQPage component - A page layout component for rendering the FAQ page.
 *
 * @component
 * @returns {JSX.Element} The rendered FAQPage component.
 *
 * @example
 * // Example usage:
 * <FAQPage />
 */
const FAQPage: React.FC = () => (
  <div className={styles['faq-page']}>
    <div className={styles['faq-header-section']}>
      <HeaderNavigation theme="light" />
      <FAQHeader />
    </div>
    <FAQText />
    <FooterMain />
  </div>
);

export default FAQPage;
